import type { SearchGroup, SearchResult } from './search-types';

interface CaseLike {
  id: string;
  navn: string;
  saksnummer: string;
  klient: string;
}

/** Finn aktiv caseId fra URL-pathen (`/cases/:caseId/...`). */
export function extractCaseId(pathname: string): string | null {
  const match = pathname.match(/\/cases\/([^/]+)/);
  return match?.[1] ?? null;
}

/** Klientsøk i brukerens saker når Typesense ikke er konfigurert. */
export function filterCases(
  cases: Array<{ case: CaseLike }> | undefined,
  query: string,
): SearchResult[] {
  if (!query.trim() || !cases?.length) return [];
  const q = query.toLowerCase();
  return cases
    .filter(
      ({ case: c }) =>
        c.navn.toLowerCase().includes(q) ||
        c.saksnummer.toLowerCase().includes(q) ||
        c.klient.toLowerCase().includes(q),
    )
    .map(({ case: c }) => ({
      id: c.id,
      group: 'Saker' as SearchGroup,
      title: c.navn,
      subtitle: `${c.saksnummer} · ${c.klient}`,
      href: `/cases/${c.id}`,
      caseId: c.id,
    }));
}
